module.exports = __webpack_public_path__ + "img/hest5.4b4e5ce5.jpg";